import { render, staticRenderFns } from "./Compositions.vue?vue&type=template&id=505bc979&"
import script from "./Compositions.vue?vue&type=script&lang=js&"
export * from "./Compositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports